module.exports = __webpack_public_path__ + "img/case-logo-19.19008e9c.png";